import jsPDF from 'jspdf';

import interBoldUrl from '@/assets/fonts/Inter-Bold.ttf?url';
import interMediumUrl from '@/assets/fonts/Inter-Medium.ttf?url';

/**
 * Inter, the same family as the marketing brochure. Medium is registered as
 * `normal` so body copy matches the brochure weight instead of Helvetica's
 * lighter Regular.
 */
export const PDF_FONT = 'Inter';

let mediumBase64: string | null = null;
let boldBase64: string | null = null;
let activeFamily = 'helvetica';

const bufferToBase64 = (buffer: ArrayBuffer): string => {
  const bytes = new Uint8Array(buffer);
  let binary = '';
  const chunk = 0x8000;
  for (let index = 0; index < bytes.length; index += chunk) {
    binary += String.fromCharCode(...bytes.subarray(index, index + chunk));
  }
  return btoa(binary);
};

const loadAsBase64 = async (url: string): Promise<string> => {
  const response = await fetch(url);
  if (!response.ok) throw new Error('PDF_FONT_LOAD_FAILED');
  return bufferToBase64(await response.arrayBuffer());
};

/** Family to use after `ensurePdfFonts`. Falls back to Helvetica if Inter did not load. */
export const pdfFont = (): string => activeFamily;

export const ensurePdfFonts = async (doc: jsPDF): Promise<void> => {
  try {
    if (!mediumBase64 || !boldBase64) {
      const [medium, bold] = await Promise.all([
        loadAsBase64(interMediumUrl),
        loadAsBase64(interBoldUrl),
      ]);
      mediumBase64 = medium;
      boldBase64 = bold;
    }

    doc.addFileToVFS('Inter-Medium.ttf', mediumBase64);
    doc.addFont('Inter-Medium.ttf', PDF_FONT, 'normal');
    doc.addFileToVFS('Inter-Bold.ttf', boldBase64);
    doc.addFont('Inter-Bold.ttf', PDF_FONT, 'bold');
    activeFamily = PDF_FONT;
    doc.setFont(PDF_FONT, 'normal');
  } catch {
    activeFamily = 'helvetica';
    doc.setFont('helvetica', 'normal');
  }
};
